import { Container, SystemStyleObject, VStack } from "@chakra-ui/react"
import CoverPageContributors from "./CoverPageContributors"
import CoverPageHeader from "./CoverPageHeader"
import CoverPageOffers from "./CoverPageOffers"
import CoverPageOverview from "./CoverPageOverview"
import CoverPagePathPreview from "./CoverPagePathPreview"
import CoverPageRelated from "./CoverPageRelated"
import { COVER_PAGE_PADDING } from "./constants"

export const CoverPageWrapper = ({
  children,
  className,
  sx,
  isFullscreen
}: {
  children: React.ReactNode
  className?: string
  sx?: SystemStyleObject
  isFullscreen?: boolean
}) => {
  return (
    <VStack
      className={`CoverPageWrapper chakra-ui-reset-css ${className || ""}`}
      gap={0}
      h="100%"
      p={0}
      w="100%"
      maxW={isFullscreen ? "100%" : "1000px"}
      bgColor="backgroundSecondary"
      borderRadius={isFullscreen ? "0" : { base: "0", md: "card" }}
      justifySelf="center"
      alignSelf="center"
      maxH={{ base: "100vh", md: "100%" }}
      transition="max-height 0.2s ease-out"
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      zIndex={1}
      sx={{
        "p, div, span": {
          lineHeight: "1.4"
        },
        //  Hide horizontal scrollbars in carousel components
        ".carousel-scroller": {
          "&::-webkit-scrollbar": {
            display: "none"
          },
          msOverflowStyle: "none", // IE and Edge
          scrollbarWidth: "none" // Firefox
        },
        // Overlay scrollbar styling
        "&::-webkit-scrollbar": {
          width: "8px"
        },
        "&::-webkit-scrollbar-track": {
          background: "transparent"
        },
        "&::-webkit-scrollbar-thumb": {
          background: "rgba(0, 0, 0, 0.2)",
          borderRadius: "4px",
          "&:hover": {
            background: "rgba(0, 0, 0, 0.3)"
          }
        },
        // Firefox overlay scrollbar
        scrollbarWidth: "thin",
        scrollbarColor: "rgba(0, 0, 0, 0.2) transparent",
        ...sx
      }}
    >
      {children}
    </VStack>
  )
}

export const CoverPage = () => {
  return (
    <CoverPageWrapper>
      <VStack
        w="100%"
        h="100%"
        gap={0}
        borderRadius={{
          base: 0,
          md: "card"
        }}
        overflowY="auto"
      >
        <CoverPageHeader />
        <Container
          maxW="1000px"
          p={0}
          // On mobile add a bit more bottom padding to allow for the toolbar
          pb={{
            base: `calc(${COVER_PAGE_PADDING.base} + 20px)`,
            md: COVER_PAGE_PADDING.md
          }}
          bgColor="backgroundSecondary"
        >
          <CoverPageOverview />
          <CoverPagePathPreview />
          <CoverPageOffers />
          <CoverPageContributors />
          <CoverPageRelated />
        </Container>
      </VStack>
    </CoverPageWrapper>
  )
}
